  class WheelRecorder {
    frameNumber = 0
    dataPoint = { frameNumber: 0, deltaX: 0 }
  
  
    constructor({ element, onFrame }) {
      this.element = element
      this.onFrame = onFrame
  
      this.onWheel = this.onWheel.bind(this)
      this.loop = this.loop.bind(this)
  
      requestAnimationFrame(this.loop)
      element.addEventListener("wheel", this.onWheel)
    }
  
    onWheel(event) {
      if (event.ctrlKey || event.shiftKey) return 
  
      if (this.dataPoint.frameNumber === this.frameNumber) {
        this.dataPoint.deltaX += event.deltaX
      } else {
        this.dataPoint.deltaX = event.deltaX
        this.dataPoint.frameNumber = this.frameNumber
      }
    }
  
    loop() {
      if (this.dataPoint.frameNumber !== this.frameNumber) {
        this.dataPoint.deltaX = 0
        this.dataPoint.frameNumber = this.frameNumber
      }

      this.onFrame(this.dataPoint.deltaX)

      this.frameNumber++
      this.requestId = requestAnimationFrame(this.loop)
    }
  
    destroy() {
      this.element.removeEventListener("wheel", this.onWheel)
      if (this.requestId !== undefined) cancelAnimationFrame(this.requestId)
    }
  }
  
  function average(arr) {
    return arr.reduce((a, b) => a + b, 0) / arr.length
  }
  
  function throttle(fn, delay) {
    let wait = false
  
    return (...args) => {
      if (wait) return
  
      wait = true
  
      window.setTimeout(() => {
        wait = false
      }, delay)
  
      return fn(...args)
    }
  }
  
  class WheelSwiper {
    tolerance = 0.15
  
    smoothLevel = 2
    smoothWidth = 10
    oldSmoothedValueDistance = 6
  
    smoothLevels = new Array(this.smoothLevel)
  
    previousPositiveDifference = 0
  
    constructor({ element, leftCallback, rightCallback, draw }) {
      for (let i = 0; i < this.smoothLevels.length; i++) {
        this.smoothLevels[i] = new Array(this.smoothWidth).fill(0)
      }
      this.draw = draw
  
      this.element = element
  
      this.rightCallback = throttle(rightCallback, 250)
      this.leftCallback = throttle(leftCallback, 250)
  
      this.wheelRecorder = new WheelRecorder({
        element: window,
        onFrame: this.storeValues.bind(this)
      })
    }
  
    storeValues(value) {
      this.smoothLevels[0].push(value)
      this.smoothLevels[0].splice(0, 1)
  
      for (let i = 1; i < this.smoothLevels.length; i++) {
        const valuesHistory = this.smoothLevels[i]
  
        value = average(this.smoothLevels[i - 1])
        valuesHistory.push(value)
        valuesHistory.splice(0, 1)
      }
  
      const positiveDifference = this.calcPositiveDifference()
  
      if (this.draw) {
        this.draw([
          this.smoothLevels[0][this.smoothLevels[0].length - 1],
          this.smoothLevels[1][this.smoothLevels[1].length - 1],
          this.smoothLevels[2][this.smoothLevels[2].length - 1],
          positiveDifference
        ])
      }
  
      if (
        this.previousPositiveDifference < this.tolerance &&
        positiveDifference >= this.tolerance
      ) {
        this.rightCallback()
      }
       if (
        this.previousPositiveDifference > -this.tolerance &&
        positiveDifference <= -this.tolerance
      ) {
        this.leftCallback()
      }
  
      this.previousPositiveDifference = positiveDifference
    }
  
    getCurrentAndOldSmoothedValues() {
      const smothValueHistory = this.smoothLevels[this.smoothLevels.length - 1]
      return {
        oldSmoothedValue:
          smothValueHistory[
            smothValueHistory.length - this.oldSmoothedValueDistance
          ],
        smoothedValue: smothValueHistory[smothValueHistory.length - 1]
      }
    }
  
    calcPositiveDifference() {
      const {
        oldSmoothedValue,
        smoothedValue
      } = this.getCurrentAndOldSmoothedValues()
  
      const difference = smoothedValue - oldSmoothedValue
  
      if (smoothedValue > 0) return Math.max(difference, 0)
      if (smoothedValue < 0) return Math.min(difference, 0)
  
      return 0
    }
  
    destroy() {
      this.wheelRecorder.destroy()
    }
  }



